module.exports = __webpack_public_path__ + "static/img/4-4.c9a104e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/4-4.png
// module id = CJEE
// module chunks = 0